// extracted by mini-css-extract-plugin
module.exports = {"addButton":"ChannelAddress_addButton__VhiBt","confirmTextName":"ChannelAddress_confirmTextName__3MQYo","addressErrorCloseBtn":"ChannelAddress_addressErrorCloseBtn__2Q664"};